<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="title"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <!-- <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button"
                            class="btn btn-primary btn-with-shadow"
                            data-toggle="modal"
                            @click="openAddEditModal">
                        {{ $t('add') }}
                    </button>
                </div>
            </div> -->
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <task-mytaskmodal
      v-if="isMYTASKModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
      :id="id"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";

export default {
  extends: CoreLibrary,
  name: "MyTasks",
  mixins: [TableHelpers],
  data() {
    return {
      title: "",
      isMYTASKModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "mytask-table",
      rowData: {},
      id: "",
      options: {
        name: "AdvanceTable",
        url: actions.MY_TASKS_LISTING,
        showHeader: true,
        columns: [
          {
            title: this.$t("task"),
            type: "custom-html",
            key: "title",
            modifier: (value, row) => {
              return `<a href="#" id="${row.id}" data-attribute="${
                row.id
              }" @click=${this.myFunction(row.id)}>${this.$t(value)}</a>`;
            },
          },
          {
            title: this.$t("assigned_to"),
            type: "component",
            key: "users",
            isVisible: true,
            className: "w-100",
            componentName: "group-of-users",
          },
          {
            title: this.$t("type"),
            type: "custom-html",
            key: "type",
            modifier: (value, row) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          // {
          //     title: this.$t('assigned_to'),
          //     type: 'custom-html',
          //     key: 'assigned_to',
          //     modifier: (value) => {
          //         return `<span>${this.$t(value)}</span>`
          //     }
          // },
          {
            title: this.$t("company"),
            type: "custom-html",
            key: "company_info",
            modifier: (value) => {
              return `<span>${this.$t(value.company_name)}</span>`;
            },
          },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "start_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("due_date"),
            type: "custom-html",
            key: "due_date",
            modifier: (value, row) => {
              var result = "";
              let ClassName = "warning";

              const moment = require("moment");
              // Define your due date and current date
              const dueDate = moment(value + " 23:59:59", "DD-MM-YYYY HH:mm:ss");
              const currentDate = moment(); // Current date and time

              // Calculate the difference in time
              const timeDiff = dueDate.diff(currentDate);
              const status = row.status;

              // If task is completed, show the exact due date
              if (status === "completed") {
                return `<span>${value}</span>`;
              } else if (timeDiff > 0) {
                const duration = moment.duration(timeDiff);
                if (duration.days() > 0) {
                  result = `${duration.days()} day${duration.days() > 1 ? "s" : ""} left`;
                  if (duration.days() > 30) {
                    ClassName = "success";
                  }
                } else if (duration.hours() > 0) {
                  result = `${duration.hours()} hour${
                    duration.hours() > 1 ? "s" : ""
                  } left`;
                } else {
                  result = `${duration.minutes()} minute${
                    duration.minutes() > 1 ? "s" : ""
                  } left`;
                }
              } else {
                result = "The due date has passed.";
                ClassName = "danger";
              }
              // return `<span>${this.$t(result)}</span>`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                result
              )}</span>`;
            },
          },
          {
            title: this.$t("priority"),
            type: "custom-html",
            key: "priority",
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "low") ClassName = `success`;
              else if (value === "medium") ClassName = `warning`;
              else if (value === "high") ClassName = `danger`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "completed") ClassName = `success`;
              else if (value === "incomplete") ClassName = `warning`;
              else if (value === "action_required") {
                ClassName = `info`;
                value = "Action Required";
              }

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "task-mytaskmodal",
            modalId: "my_task_modal",
            id: "id",
          },
        ],
        filters: [
          {
            title: this.$t("date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "nextYear"],
          },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          {
            title: this.$t("priority"),
            type: "checkbox",
            key: "priority",
            option: [
              { id: "low", value: "Low" },
              { id: "medium", value: "Medium" },
              { id: "high", value: "High" },
            ],
          },
          {
            title: this.$t("status"),
            type: "checkbox",
            key: "status",
            option: [
              { id: "completed", value: "Completed" },
              { id: "incomplete", value: "Incomplete" },
              // {id: 'invited', value: 'Invited'},
            ],
          },
          {
            title: this.$t("task_type"),
            type: "radio",
            key: "task_type",
            option: [
              { id: "company_tasks", value: "Company Tasks" },
              { id: "my_tasks", value: "My Tasks" },
              { id: "auditRequest", value: "Audit Request" },
            ],
            header: {
              title: this.$t("want_to_filter_your_list"),
              description: this.$t(
                "you_can_filter_your_data_table_which_are_created_based_on_gender"
              ),
            },
          },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "asc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    closeAddEditModal() {
      $("#my_task_modal").modal("hide");
      this.isMYTASKModalActive = false;
      // this.searchAndSelectFilterOptions();
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      this.$store.commit("updateSharedData", { index: "taskData", newValue: rowData });
      this.$store.commit("updateSharedData", { index: "taskId", newValue: rowData.id });
      // this.id = rowData.recurring_task_id;

      if (actionObj.title == this.$t("view")) {
        // window.location = "/admin/assign/form";
        // alert(rowData.id);
        this.selectedUrl = `${actions.MY_TASK_SHOW}/${rowData.id}`;
        // // this.openAddEditModal();
        // this.id = rowData.id
        this.$emit("id", rowData.id);
        // this.isMYTASKModalActive = true;
      }
    },

    view(id) {
      this.$store.commit("updateSharedData", { index: "taskId", newValue: id });
      this.id = id;
      this.$emit("id", id);
    },
    myFunction(id) {
      let doc = document.getElementById(id);
      if (doc) {
        doc.addEventListener("click", () => {
          this.view(doc.dataset.attribute);
        });
      }
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name =
          response.data &&
          this.options.filters.find(
            (element) => element.title === this.$t("search_and_select")
          );

        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
    setTaskType() {
      let myLocation = location.href;
      let split = myLocation.split("/");
      let type = split[5].split("?")[0];
      if (type == "mytasks") {
        this.options.url = actions.MY_TASKS_LISTING;
        this.title = "My Tasks";
      } else {
        this.options.url = actions.MY_TASKS_LISTING + "?task_type=" + type;
        this.title = "Site Tasks";
      }
    },
  },
  mounted() {
    this.setTaskType();
  },
};
</script>
